import * as v from "valibot";

import { rpcContract } from "../rpc";

export const postsQueryRpcContract = rpcContract({
  name: "postsQuery",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    posts: v.array(
      v.object({
        id: v.string(),
        teaser: v.nullable(v.string()),
        mediaUrl: v.nullable(v.string()),
        status: v.union([v.literal("live"), v.literal("draft"), v.literal("planned")]),
        createdAt: v.string(),
        publishedAt: v.nullable(v.string()),
        startDate: v.nullable(v.string()),
        endDate: v.nullable(v.string()),
        contentTier: v.picklist(["free", "premium"]),
        worlds: v.array(
          v.object({
            id: v.string(),
          }),
        ),
      }),
    ),
    counts: v.object({
      live: v.number(),
      draft: v.number(),
      planned: v.number(),
      free: v.number(),
      premium: v.number(),
    }),
  }),
});

export type PostsQueryParams = v.InferOutput<(typeof postsQueryRpcContract)["paramsSchema"]>;
export type PostsQueryResult = v.InferOutput<(typeof postsQueryRpcContract)["resultSchema"]>;
export type Post = v.InferOutput<(typeof postsQueryRpcContract)["resultSchema"]>["posts"][0];
export type PostStatus = Post["status"];
